import React from 'react';
import {
  BoltIcon,
  FireIcon,
  ClockIcon,
  PauseIcon,
  ArchiveBoxIcon
} from '@heroicons/react/24/outline';

const PriorityBadge = ({ priority, showDescription = false }) => {
  const getPriorityConfig = () => {
    switch (priority?.toLowerCase()) {
      case 'critical':
      case '1':
        return {
          icon: <BoltIcon className="w-4 h-4" />,
          label: 'Critical',
          description: 'Just connected (<5 min)',
          colorClass: 'text-red-700 bg-red-100',
          borderClass: 'border-red-300',
          priority: 1
        };

      case 'high':
      case '2':
        return {
          icon: <FireIcon className="w-4 h-4" />,
          label: 'High',
          description: 'Online or recently offline (<1h)',
          colorClass: 'text-orange-700 bg-orange-100',
          borderClass: 'border-orange-300',
          priority: 2
        };

      case 'medium':
      case 'normal':
      case '3':
        return {
          icon: <ClockIcon className="w-4 h-4" />,
          label: 'Medium',
          description: 'Offline 1-24 hours',
          colorClass: 'text-yellow-700 bg-yellow-100',
          borderClass: 'border-yellow-300',
          priority: 3
        };

      case 'low':
      case '4':
        return {
          icon: <PauseIcon className="w-4 h-4" />,
          label: 'Low',
          description: 'Offline 1-30 days',
          colorClass: 'text-blue-700 bg-blue-100',
          borderClass: 'border-blue-300',
          priority: 4
        };

      case 'archive':
      case '5':
      default:
        return {
          icon: <ArchiveBoxIcon className="w-4 h-4" />,
          label: 'Archive',
          description: 'Offline >30 days',
          colorClass: 'text-gray-600 bg-gray-100',
          borderClass: 'border-gray-300',
          priority: 5
        };
    }
  };

  const config = getPriorityConfig();

  return (
    <div className="inline-flex flex-col gap-0.5">
      <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${config.colorClass} ${config.borderClass} border`}>
        {config.icon}
        <span>{config.label}</span>
        <span className="text-xs opacity-70">({config.priority})</span>
      </div>
      {showDescription && (
        <span className="text-xs text-gray-500 ml-2">{config.description}</span>
      )}
    </div>
  );
};

export default PriorityBadge;